import {
  USER_SUB_LOCATIONS_REQUEST,
  USER_SUB_LOCATIONS_SUCCESS,
  USER_SUB_LOCATIONS_FAILURE
} from '../actions/sub-locations'

export default function (state = {}, action) {
  switch (action.type) {
    case USER_SUB_LOCATIONS_SUCCESS:
      return {
        ...state,
        ...action.payload.sub_locations
      }

    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/sub-locations.js